import React, { useMemo } from "react";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

const generoTexto = (gen) => {
  if (gen === "V") return "Varonil";
  if (gen === "F") return "Femenil";
  if (gen === "M") return "Mixta";
  return gen || "";
};

const getNombreCategoria = (eventSubEvents, codMod, gen, codCat) => {
  const modalidad = eventSubEvents && eventSubEvents["modalidad_" + codMod];
  const categoria =
    modalidad &&
    modalidad.ramaCat &&
    modalidad.ramaCat["rama_" + gen] &&
    modalidad.ramaCat["rama_" + gen].categorias &&
    modalidad.ramaCat["rama_" + gen].categorias["categoria_" + codCat];
  return categoria ? categoria.nombreCategoria : "";
};

export default function PorTerminarDetail({
  pendingList,
  pendingByModalidad,
  eventSubEvents,
}) {
  const totalesPorModalidad = pendingByModalidad || {};

  const modalidadesOrdenadas = useMemo(() => {
    return Object.keys(eventSubEvents || {}).sort(
      (a, b) =>
        (eventSubEvents[a].codigoModalidad || 0) -
        (eventSubEvents[b].codigoModalidad || 0)
    );
  }, [eventSubEvents]);

  const listaOrdenada = useMemo(() => {
    return [...(pendingList || [])].sort((a, b) => {
      if (a.codMod !== b.codMod) return a.codMod - b.codMod;
      return (a.nombre || "").localeCompare(b.nombre || "");
    });
  }, [pendingList]);

  const listaPorModalidad = useMemo(() => {
    const grupos = {};
    listaOrdenada.forEach((atleta) => {
      const key = "modalidad_" + atleta.codMod;
      if (!grupos[key]) grupos[key] = [];
      grupos[key].push(atleta);
    });
    return grupos;
  }, [listaOrdenada]);

  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h4" component="h2" gutterBottom>
        Atletas por terminar
      </Typography>

      <Paper style={{ padding: 15, marginBottom: 20, backgroundColor: "#e0e0e0" }}>
        <Typography variant="h6" gutterBottom>
          Totales por distancia
        </Typography>
        <Grid container spacing={2}>
          {modalidadesOrdenadas.map((key) => {
            const codigoModalidad = eventSubEvents[key].codigoModalidad;
            const total = totalesPorModalidad["modalidad_" + codigoModalidad] || 0;
            return (
              <Grid item xs={6} sm={3} key={key}>
                <Paper style={{ padding: 10, textAlign: "center" }}>
                  <Typography variant="subtitle2">
                    {eventSubEvents[key].descripcionModalidad}
                  </Typography>
                  <Typography variant="h4" color="primary">
                    {total}
                  </Typography>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </Paper>

      <Typography variant="h6" gutterBottom>
        Listado detallado ({listaOrdenada.length})
      </Typography>

      {modalidadesOrdenadas.map((key) => {
        const codigoModalidad = eventSubEvents[key].codigoModalidad;
        const atletasModalidad = listaPorModalidad["modalidad_" + codigoModalidad] || [];

        return (
          <div key={key} style={{ marginBottom: 25 }}>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }} gutterBottom>
              {eventSubEvents[key].descripcionModalidad} ({atletasModalidad.length})
            </Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Número</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell align="center">Género</TableCell>
                  <TableCell align="center">Categoría</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {atletasModalidad.map((atleta, index) => (
                  <TableRow key={atleta.num + "-" + index}>
                    <TableCell align="center">{atleta.num}</TableCell>
                    <TableCell>{atleta.nombre}</TableCell>
                    <TableCell align="center">{generoTexto(atleta.gen)}</TableCell>
                    <TableCell align="center">
                      {getNombreCategoria(eventSubEvents, atleta.codMod, atleta.gen, atleta.codCat)}
                    </TableCell>
                  </TableRow>
                ))}
                {atletasModalidad.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No hay atletas por terminar en esta distancia
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        );
      })}
    </div>
  );
}
